import { AdminAssignedInterviewModal } from './AdminAssignedInterviewModal';

export default AdminAssignedInterviewModal;